import * as types from '../../action-types';
import {getAllEmergencyContacts as initialState } from "../../initialState";

const getAllEmergencyContacts = (state=initialState, action) => {
  switch (action.type) {
    case types.GET_ALL_EMERGENCY_CONTACTS_START:
      return {
        ...state,
        isLoading: true
      };
    case types.GET_ALL_EMERGENCY_CONTACTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.GET_ALL_EMERGENCY_CONTACTS_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.GET_ALL_EMERGENCY_CONTACTS_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default getAllEmergencyContacts;
